import { EDigestiveConditions } from "@/app/types/enumerations";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { useTranslation } from "react-i18next";

interface ConditionsFilterProps {
  onValueChange: (value: EDigestiveConditions) => void;
}

export const ConditionsFilter = ({ onValueChange }: ConditionsFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center gap-2">
      <Paragraph>{t("patients.search.filters.conditions.title")}</Paragraph>
      <Select onValueChange={onValueChange}>
        <SelectTrigger className={`min-w-[284px] min-h-12`}>
          <SelectValue
            placeholder={t("patients.search.filters.conditions.placeholder")}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value={EDigestiveConditions.IBD}>
              {t(`conditions.${EDigestiveConditions.IBD.toLowerCase()}`)}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.CELIAC_DISEASE}>
              {t(
                `conditions.${EDigestiveConditions.CELIAC_DISEASE.toLowerCase()}`
              )}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.DYSPEPSIA}>
              {t(`conditions.${EDigestiveConditions.DYSPEPSIA.toLowerCase()}`)}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.IBS}>
              {t(`conditions.${EDigestiveConditions.IBS.toLowerCase()}`)}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.FRUCTOSE_INTOLERANCE}>
              {t(
                `conditions.${EDigestiveConditions.FRUCTOSE_INTOLERANCE.toLowerCase()}`
              )}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.GASTRITIS}>
              {t(`conditions.${EDigestiveConditions.GASTRITIS.toLowerCase()}`)}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.LACTOSE_INTOLERANCE}>
              {t(
                `conditions.${EDigestiveConditions.LACTOSE_INTOLERANCE.toLowerCase()}`
              )}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.PEPTIC_ULCER}>
              {t(
                `conditions.${EDigestiveConditions.PEPTIC_ULCER.toLowerCase()}`
              )}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.REFLUX}>
              {t(`conditions.${EDigestiveConditions.REFLUX.toLowerCase()}`)}
            </SelectItem>
            <SelectItem value={EDigestiveConditions.NULL}>
              {t(`conditions.${EDigestiveConditions.NULL.toLowerCase()}`)}
            </SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
